import {
  TRADE_PARTNER_AVERAGE_INVOICE_AMOUNT,
  TRADE_PARTNER_DOCUMENTS_ROUTED_THROUGH_BANK,
  TRADE_PARTNER_EXPECTED_EXPORT_VOLUME,
  TRADE_PARTNER_HAS_DELAY_IN_PAYMENTS,
  TRADE_PARTNER_HAS_TRADE_HISTORY,
  TRADE_PARTNER_MAXIMUM_DELAY_IN_DAYS,
  TRADE_PARTNER_MAXIMUM_PAYMENT_TERM,
  TRADE_PARTNER_OUTSTANDING_BALANCE,
  TRADE_PARTNER_PAYMENT_REFERENCE_TYPE,
  TRADE_PARTNER_TOTAL_EXPORT_VOLUME,
  TRADE_PARTNER_TRADING_CURRENCY,
  TRADE_PARTNER_TRADING_SINCE,
  TRADE_PARTNER_INVOICE_DOCUMENT,
  TRADE_PARTNER_PURCHASE_ORDER_DOCUMENT,
  TRADE_PARTNER_BILL_OF_LADING_DOCUMENT,
  TRADE_PARTNER_AIRWAY_BILL_DOCUMENT,
  TRADE_PARTNER_CRM_CIM_DOCUMENT,
  TRADE_PARTNER_EBRC_DOCUMENT,
  TRADE_PARTNER_SUPPORTING_DOCUMENT,
  TRADE_PARTNER_PROOF_OF_PAYMENT,
  INPUT_FIELD_DOCUMENT_TYPE_MAP,
  TRADE_PARTNER_SAMPLE_DOC_STATEMENT_OF_ACCOUNTS,
  TRADE_PARTNER_SAMPLE_DOC_AGING_REPORT,
  TRADE_PARTNER_CITY,
  TRADE_PARTNER_COMPANY_NAME,
  TRADE_PARTNER_COUNTRY_CODE,
  TRADE_PARTNER_STATE,
  TRADE_PARTNER_STREET_NAME,
  TRADE_PARTNER_STREET_NUMBER,
  TRADE_PARTNER_ZIP_CODE,
  TRADE_PARTNER_WEBSITE,
  TRADE_PARTNER_LEGAL_FORM,
  TRADE_PARTNER_EXPECTED_FINANCING_LIMIT,
} from '@modifi/plugin-onboarding'
import {FeInputFieldStatus, DocumentType} from '@modifi/enums'

export const TRADE_PARTNER_TRANSPORT_DOCUMENT_INPUT_FIELD_NAMES: string[] = [
  TRADE_PARTNER_BILL_OF_LADING_DOCUMENT,
  TRADE_PARTNER_AIRWAY_BILL_DOCUMENT,
  TRADE_PARTNER_CRM_CIM_DOCUMENT,
]

export const TRADE_PARTNER_DOCUMENT_INPUT_FIELD_NAMES: string[] = [
  TRADE_PARTNER_PURCHASE_ORDER_DOCUMENT,
  TRADE_PARTNER_SAMPLE_DOC_STATEMENT_OF_ACCOUNTS,
  TRADE_PARTNER_INVOICE_DOCUMENT,
  TRADE_PARTNER_EBRC_DOCUMENT,
  TRADE_PARTNER_PROOF_OF_PAYMENT,
  TRADE_PARTNER_SUPPORTING_DOCUMENT,
  TRADE_PARTNER_SAMPLE_DOC_AGING_REPORT,
]

export const TRADE_PARTNER_TRANSPORT_DOCUMENT_TYPES: string[] =
  TRADE_PARTNER_TRANSPORT_DOCUMENT_INPUT_FIELD_NAMES.map(
    fieldName => INPUT_FIELD_DOCUMENT_TYPE_MAP[fieldName]
  )

export const TRADE_PARTNER_INPUT_FIELD_NAMES: string[] = [
  TRADE_PARTNER_AVERAGE_INVOICE_AMOUNT,
  TRADE_PARTNER_DOCUMENTS_ROUTED_THROUGH_BANK,
  TRADE_PARTNER_EXPECTED_EXPORT_VOLUME,
  TRADE_PARTNER_HAS_DELAY_IN_PAYMENTS,
  TRADE_PARTNER_HAS_TRADE_HISTORY,
  TRADE_PARTNER_MAXIMUM_DELAY_IN_DAYS,
  TRADE_PARTNER_MAXIMUM_PAYMENT_TERM,
  TRADE_PARTNER_OUTSTANDING_BALANCE,
  TRADE_PARTNER_PAYMENT_REFERENCE_TYPE,
  TRADE_PARTNER_TOTAL_EXPORT_VOLUME,
  TRADE_PARTNER_TRADING_CURRENCY,
  TRADE_PARTNER_TRADING_SINCE,
  TRADE_PARTNER_CITY,
  TRADE_PARTNER_COMPANY_NAME,
  TRADE_PARTNER_COUNTRY_CODE,
  TRADE_PARTNER_STATE,
  TRADE_PARTNER_STREET_NAME,
  TRADE_PARTNER_STREET_NUMBER,
  TRADE_PARTNER_ZIP_CODE,
  TRADE_PARTNER_WEBSITE,
  TRADE_PARTNER_LEGAL_FORM,
  TRADE_PARTNER_EXPECTED_FINANCING_LIMIT,
]

export const STATUS_MAPPING = {
  APPROVED: FeInputFieldStatus.VERIFIED,
  DECLINED: FeInputFieldStatus.DENIED,
  PENDING: FeInputFieldStatus.PENDING,
  ON_HOLD: FeInputFieldStatus.PENDING,
  LIMIT_AVAILABLE: FeInputFieldStatus.PENDING,
}

export const EXPECTED_FINANCING_LIMIT_CAP = {
  medium: 750000,
  high: 2500000,
}

export const REQUIRED_DOCS_FOR_HIGH_FINANCING_LIMIT = [
  DocumentType.KYC_SAMPLE_PURCHASE_ORDER,
  DocumentType.KYC_STATEMENT_OF_ACCOUNTS,
]
